/* eslint-disable */
import api from './api';

export const analytics = (route) => {
    api.post('/analytics', { route });
}